import { createContext } from "react";

import type { App } from "./utils";
import type { Account } from "@/schemas";

interface SwitchAccountOpts {
  shouldRedirect?: boolean;
}

interface AuthContextProps {
  currentAccount: Account | null;
  isLoggedIn: boolean;
  otherAccounts: Account[];

  addAccount(token: string, account: Account, app: App): void;
  logOut(): Promise<void>;
  switchAccount(account: Account, opts?: SwitchAccountOpts): void;
  updateCurrentAccount(account: Account): void;
}

const AuthContext = createContext({} as AuthContextProps);

export { AuthContext as default, type AuthContextProps, type SwitchAccountOpts };
